import SubmissionsTab from "./SubmissionsTab";

export default function JobSeekersTab(props) {
  return <SubmissionsTab {...props} collectionName="jobSeekers" label="Job Seekers"
    summaryKeys={["fullName", "desiredRole"]}/>;
}
